import { render, staticRenderFns } from "./keepclean-list.vue?vue&type=template&id=50fafcc7"
import script from "./keepclean-list.vue?vue&type=script&lang=js"
export * from "./keepclean-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports